export const MODE = {
    PRESENCIAL: "Presencial",
    ONLINE: "Online",
  };